<template>
  <TwoColPageWrapper class="prod-page" :menuItems="menuItems" :breadcrumbs="breadcrumbs" leftBanner>
        <h1 class="catitem-name">{{ product.name }}</h1>
        <div class="catitem-full">
          <section class="catitem-descr">
            <div class="catitem-photo">
              <da-img
                :src="product.fileImgs && product.fileImgs[0] && product.fileImgs[0].url"
                :alt="product.fileImgs && product.fileImgs[0] && product.fileImgs[0].filename"
                :aspect-ratio="1.248"
                max-width="381"
              />
            </div>
            <div class="catitem-detail">
              <div v-if="product.items && product.items[selVendorCodeIndex] && product.items[selVendorCodeIndex].cost" class="red--text title mb-3" :class="{'mt-5': $vuetify.breakpoint.xs}">Цена: {{product.items[selVendorCodeIndex].cost | currency}}</div>
              <div class="caption mb-3">{{product.text && product.text.replace(/<\/?[^>]+(>|$)/g, "")}}</div>
              <div
                @click="isOneVendorCode ? showVCodeList = !showVCodeList : ''"
                :class="isOneVendorCode ? 'price-list-title' : ''"
                id="price-list-title"
              >
                <span>{{ product.name }}</span>
                <ul v-if="showVCodeList" class="offers-list">
                  <li
                    v-for="(item, i) in product.items || []"
                    :key="i"
                    :class="{ active: selVendorCodeIndex === i }"
                    @click="selVendorCodeIndex = i; isHideQ = false; count = 1"
                  >
                    <span v-if="item.pack" class="pack">{{item.pack.name}}</span> 
                    <span v-if="item.color" class="color-item">{{', цвет ' + item.color.name}}</span>
                    <span v-if="item.cost"> - {{item.cost | currency}}</span>
                  </li>
                </ul>
              </div>

              <div class="articul" id="item_name">
                Название:
                <span class="articul">{{ product.name }}</span>
              </div>

              <div class="articul" id="articul">
                Артикул:
                <span class="articul">
                  {{
                    product.items && product.items[selVendorCodeIndex].sku
                  }}</span
                >
                <span v-if="product.vendor_code2 && product.vendor_code2[selVendorCodeIndex]">
                    {{'+ ' + product.vendor_code2[selVendorCodeIndex]}}
                </span>
              </div>

              <div class="pack" id="pack">
                Упаковка:
                <span>
                  <span v-if="product.items && product.items[selVendorCodeIndex] && product.items[selVendorCodeIndex].pack">{{
                    product.items[selVendorCodeIndex].pack.name
                  }}</span>
                </span>
              </div>

              <div class="color" id="color">
                Цвет:
                <span class="item-all-colors">
                  <span v-if="product.items && product.items[selVendorCodeIndex] && product.items[selVendorCodeIndex].color" class="color-item">{{
                    product.items[selVendorCodeIndex].color.name
                  }}</span>
                </span>
              </div>
            </div>
          </section>

          <section class="catitem-links catitem-section">
            <div class="catitem-link-wrapper">
              <router-link
                :to="{name: 'calc'}"
                class="catitem-link-calc  bottom_line"
                ><span>Калькулятор расхода</span></router-link
              >
            </div>
            <div class="catitem-link-wrapper">
              <a @click.prevent="dialog = true" class="catitem-link-mail">Задать вопрос</a>
            </div>
            <form class="s-form" style="max-width: 280px;">
                <v-fade-transition hide-on-leave>
                   <div v-if="isHideQ" class="s-wrap">
                <button
                  @click.prevent="isHideQ = false"
                  class="s-btn s-btn-success"
                >
                  Добавить еще
                </button>
                <button
                  @click.prevent="$router.push({ name: 'cart' })"
                  class="s-btn s-btn-primary"
                >
                  Перейти в корзину
                </button>
              </div> 
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
              <div v-if="!isHideQ" class="s-wrap">
                <button
                  @click.prevent="addToCart"
                  class="s-btn s-btn-primary add-cart-btn"
                >
                  <i class="fas fa-shopping-cart"></i> Добавить в корзину
                </button>
                <input
                 class="mr-2"
                  v-model.number="count"
                  style="width: 50px;"
                  type="number"
                  min="1"
                  max="99"
                  value="1"
                />
                шт.
              </div>
              </v-fade-transition>
            </form>
            <!--				<div class="catitem-link-wrapper">
					<a href="/wherebuy/" class="catitem-link-dealer">Найти дилера</a>
				</div>
				<div class="catitem-link-wrapper">
					<a href="index.html#" class="product-response-show-list">Отзывы <span class="product-response-show-list-min-text">(0)</span></a>
				</div>-->
          </section>
          <section class="catitem-product-response">
            <div class="b-ib-product-response b-ib-product-response--empty">
              Нет ни одной записи
              <div class="b-ib-product-response__add-response">
                <button class="b-ib-product-response__add-response-button">
                  Оставить отзыв
                </button>
              </div>
            </div>
          </section>

          <section class="catitem-section">
            <h2 class="h3-style">Применение {{ product.name }}</h2>

            <div>
              <ul>
                <li v-for="use in product.uses">
                  {{ use.text }}
                </li>
              </ul>
            </div>
          </section>

          <section class="catitem-section">
            <h2 class="h3-style">Характеристики / преимущества {{ product.name }}</h2>

            <div>
              <ul>
                <li v-for="option in product.details">{{option.text}}</li>
              </ul>
            </div>
          </section>

          <section class="catitem-section">
              <v-row>
                  <v-col cols="12" md="6">
                      <h3>Цвет</h3>
                        <div class="d-flex align-center">
                            <!-- <v-img
                            class="mr-3"
                            src="/upload/iblock/1d1/1d104cdc6cb07ef2f2845404f8fd2120.png"
                            maxWidth="130"
                            :aspect-ratio="3.86"
                            /> -->
                            <div v-if="product.catalogColors && product.catalogColors.length">
                                <div v-for="(color, index) in product.catalogColors" :key="index">
                                    {{ color.name }}
                                </div>
                            </div>
                        </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3 class="mb-5">Расход</h3>

                    <div class="mt--p" v-html="product.consumption"></div>
                  </v-col>
              </v-row>
          </section>

    <v-slide-x-reverse-transition group>
        <section v-if="product.fileDocs && product.fileDocs.length" :key="1" class="catitem-files catitem-section">
                <h3>Документы</h3>

                <div>
                    <ul class="workpage-file-list">
                        <li v-for="(file, index) in product.fileDocs" :key="index">
                            <a :href="file.url" target="_blank">{{file.origname}}</a>
                        </li>
                    </ul>
                </div>
            </section>



            <section v-if="product.video && product.video.length" :key="2" class="catitem-files catitem-section">
                <h3>Видео</h3>

                <div class="video">
                    <v-row>
                        <v-col v-for="(video, index) in product.video" :key="index"  cols="12" md='4'>
                            <DaYoutubePlayer :src="video.url" width="100%"></DaYoutubePlayer>
                        </v-col>
                    </v-row>
                </div>
            </section>
    </v-slide-x-reverse-transition>
          
        </div>

        <div class="popup-layout catitem-popup-layout ask-question">
          <div class="popup-container-wrapper catitem-mailform-wrapper">
            <div class="popup-container">
              <div class="header catitem-mailform-header">
                <div class="title catitem-mailform-title">Задать вопрос</div>
                <a class="popup-close-button" href="index.html#"></a>
              </div>
              <div class="body catitem-mailform-title">
                <form
                  name="SIMPLE_FORM_1"
                  action="index.html"
                  method="POST"
                  enctype="multipart/form-data"
                >
                  <input
                    type="hidden"
                    name="sessid"
                    id="sessid"
                    value="5419e59ee7d217b80822463a814aae42"
                  /><input type="hidden" name="WEB_FORM_ID" value="1" /><input
                    type="hidden"
                    name="lang"
                    value="ru"
                  />
                  <div class="form-field">
                    <span class="">Ваше имя</span><br /><input
                      type="text"
                      placeholder="Ваше имя"
                      name="form_text_26"
                      value=""
                      size="0"
                    />
                  </div>

                  <div class="form-field">
                    <span class="">Введите Ваш e-mail</span><br /><input
                      type="text"
                      placeholder="Ваш e-mail"
                      name="form_email_1"
                      value=""
                      size="80"
                    />
                  </div>

                  <div class="form-field">
                    <span class="">Текст вопроса</span><br /><textarea
                      name="form_textarea_27"
                      placeholder="Текст вопроса"
                      cols="57"
                      rows="9"
                    ></textarea>
                  </div>

                  <div class="form-field">
                    <input
                      type="hidden"
                      id="catitem_url"
                      name="form_hidden_3"
                      value=""
                    />
                  </div>

                  <div class="form-field">
                    <input
                      type="hidden"
                      id="catitem_name"
                      name="form_hidden_2"
                      value=""
                    />
                  </div>

                  <div class="form-field">
                    <input
                      type="submit"
                      name="web_form_submit"
                      value="Отправить"
                    />
                  </div>
                </form>
                <p style="font-size: 11px; line-height: 1.2;">
                  <input type="checkbox" id="question_personal" />
                  <label for="question_personal"
                    ><span></span> Я соглашаюсь с
                    <a
                      href="/Politika-konfidentsialnosti-_Personalnye-dannye_.pdf"
                      target="_blank"
                      style="border-bottom: 1px solid #d70202;"
                      >Политикой конфиденциальности обработки персональных
                      данных</a
                    >
                    и даю согласие на обработку своих персональных данных.
                  </label>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-layout catitem-popup-layout product-response">
          <div class="popup-container-wrapper catitem-mailform-wrapper">
            <div class="popup-container">
              <div class="header catitem-mailform-header">
                <div class="title catitem-mailform-title">
                  Оставьте ваш отзыв
                </div>
                <a class="popup-close-button" href="index.html#"></a>
              </div>
              <div class="body catitem-mailform-title">
                <div id="comp_b02b5cbcf6acdf1aa79219a1a7fa40b8">
                  <form
                    id="review-form"
                    name="iblock_add"
                    action="index.html"
                    method="post"
                    enctype="multipart/form-data"
                  >
                    <input
                      type="hidden"
                      name="bxajaxid"
                      id="bxajaxid_b02b5cbcf6acdf1aa79219a1a7fa40b8_8BACKi"
                      value="b02b5cbcf6acdf1aa79219a1a7fa40b8"
                    /><input type="hidden" name="AJAX_CALL" value="Y" />
                    <input
                      type="hidden"
                      name="sessid"
                      id="sessid_1"
                      value="5419e59ee7d217b80822463a814aae42"
                    />
                    <table class="data-table review_table">
                      <thead>
                        <tr>
                          <td colspan="2">&nbsp;</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="hidetr review_tr">
                          <td>
                            <input
                              placeholder="Название"
                              type="text"
                              name="PROPERTY[NAME][0]"
                              size="25"
                              value="Post 12.05.2020 - 10:56"
                            /><br /><br />
                          </td>
                        </tr>
                        <tr class=" review_tr">
                          <td>
                            <input
                              placeholder="Имя*"
                              type="text"
                              name="PROPERTY[65][0]"
                              size="25"
                              value=""
                            /><br /><br />
                          </td>
                        </tr>
                        <tr class=" review_tr">
                          <td>
                            <input
                              placeholder="Email*"
                              type="text"
                              name="PROPERTY[66][0]"
                              size="25"
                              value=""
                            /><br /><br />
                          </td>
                        </tr>
                        <tr class=" review_tr">
                          <td>
                            <textarea
                              placeholder="Отзыв*"
                              cols="30"
                              rows="5"
                              name="PROPERTY[67][0]"
                            ></textarea>
                          </td>
                        </tr>
                        <tr class="hidetr review_tr">
                          <td>
                            <input
                              placeholder="Привязка к элементу каталога"
                              type="text"
                              name="PROPERTY[68][0]"
                              size="25"
                              value="1393"
                            /><br /><br />
                          </td>
                        </tr>
                        <tr class=" review_tr">
                          <td>
                            <input
                              type="hidden"
                              name="PROPERTY[93][0]"
                              value=""
                            />

                            <input
                              multiple
                              name="PROPERTY_FILE_93[]"
                              type="file"
                            />
                            <input
                              type="hidden"
                              name="PROPERTY[93][1]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][2]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][3]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][4]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][5]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][6]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][7]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][8]"
                              value=""
                            />

                            <input
                              type="hidden"
                              name="PROPERTY[93][9]"
                              value=""
                            />
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="2">
                            <input
                              type="submit"
                              id="review-submit"
                              name="iblock_submit"
                              value="Отправить"
                            />
                            <input
                              type="button"
                              id="review-send"
                              name="iblock_submit"
                              value="Отправить"
                            />
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </form>
                </div>
                <p style="font-size: 11px; line-height: 1.2;">
                  <input type="checkbox" id="response_personal" />
                  <label class="checkbox-label" for="response_personal"
                    ><span></span> Я соглашаюсь с
                    <a
                      href="/Politika-konfidentsialnosti-_Personalnye-dannye_.pdf"
                      target="_blank"
                      style="border-bottom: 1px solid #d70202;"
                      >Политикой конфиденциальности обработки персональных
                      данных</a
                    >
                    и даю согласие на обработку своих персональных данных.
                  </label>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Задать вопрос
        </v-card-title>

          <v-window v-model="step">
            <v-window-item :value="1">
              <v-card-text>
                <v-form>
                <v-text-field
                  v-model="name"
                  label="Имя *"
                  v-validate="'required'"
                  :error-messages="errors && errors.first('name')"
                  name="name"
                ></v-text-field>
                <da-phone-field
                  v-model="phone"
                  v-validate="'required|phone'"
                  :error-messages="errors && errors.first('phone')"
                  name="phone"
                  label="Телефон для связи *"
                ></da-phone-field>
                <v-textarea
                    v-model="comment"
                    v-validate="'required'"
                    :error-messages="errors && errors.first('comment')"
                    name="comment"
                    label="Вопрос"
                    outlined
                    class="mt-2"
                ></v-textarea>
                <span class="caption grey--text text--darken-1">
                  * поля, обязательные для заполения
                </span>
                </v-form>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
              <div class="pa-4 text-center">
                <v-icon class="mb-4" size="100" color="success"
                  >done</v-icon
                >
                <div class="title font-weight-light">
                  <div class="font-weight-bold">
                    Ваш вопрос принят в обработку
                  </div>
                  в ближайшее время с вами свяжется наш менеджер
                </div>
                <span class="caption grey--text">Спасибо за обращение</span>
              </div>
            </v-window-item>
          </v-window>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            color="red"
            text
            @click="step === 1 ? sendComment() : (dialog = false)"
          >
            {{step === 1 ? 'Отправить' : 'Закрыть'}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog><!--Модальное окно -->

  </TwoColPageWrapper>
</template>

<script>
import ProdMixin from "@/mixins/ProdMixin.vue";
import CatLeftMenuMixin from "@/components/pages/categories/CatLeftMenuMixin.vue";
import DaPhoneField from "~~/components/form/DaPhoneField.vue";
import { mapState, mapGetters } from "vuex";

export default {
    inject: ["$validator"],
  mixins: [ProdMixin, CatLeftMenuMixin],
  components: {DaPhoneField},
  created() {
      this.prodMixinInit();
    this.prodId = parseInt(this.$route.params.id);
    this.fetchProducts();
  },
  data() {
    return {
      prodId: null,
      count: 1,
      isHideQ: false,
      showVCodeList: false,
      selVendorCodeIndex: 0,
      dialog: false,
      loading: false,
      name: null,
      phone: null,
      comment: null,
      step: 1
    };
  },

  methods: {
    addToCart() {
      this.$store.commit("Cart/addProduct", {
        ...this.product,
        count: this.count,
        vendor_code: this.product.items[this.selVendorCodeIndex] ? this.product.items[this.selVendorCodeIndex].sku : null,
        vendor_code2: this.product.vendor_code2 && this.product.vendor_code2[this.selVendorCodeIndex],
        cost: this.product.items[this.selVendorCodeIndex] ? this.product.items[this.selVendorCodeIndex].cost : null,
      });
      this.isHideQ = true;
    },
    async sendComment() {
      if (!(await this.$validator.validateAll())) return;
      this.loading = true;
      await this.$store.dispatch("Cart/createOrder", {
          name: this.name,
          phone: this.phone,
          comment: this.comment,
          context: this,
      }).finally(() => (this.loading = false));
      this.step = 2;
    },
  },

  computed: {
    isOneVendorCode() {
        return this.product.items && this.product.items.length > 1
    },
    product() {
      return this.curProducts.find((p) => p.id === this.prodId) || {};
    },
    breadcrumbs() {
      return [
        {
          label: "Главная",
          to: {name: "main"},
        },
        {
          label: "Каталог",
          to: {name: "categories"},
        },
        {
          label: this.category.name,
          to: {name: "category", params: {
            groupId: this.groupId,
          }}
        },
        {
          label: this.product.name,
        },
      ];
    },
    ...mapGetters(['getListItem'])
  },
};
</script>

<style lang="scss" scoped>
.prod-page {
    .catitem-name{
        margin-bottom: 0;
    }
    .s-wrap{
        min-width: 252px;
        height: 41px;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        input{
            border: 1px solid #CCC;
            height: 41px;
            min-width: 70px;
            padding: 8px;
        }
    }
  .add-cart-btn {
    margin-right: 5px !important;
  }
  .s-btn-success {
    margin-right: 5px !important;
  }

  .mt--p {
    margin-top: -14px;
  }

  .video{
      display: flex;
      align-items: center;
      justify-content: space-between;
  }

@media screen and (min-width: 900px) {
    .video{
        flex-wrap: nowrap;
      iframe:not(:first-child){
          margin-left: 12px;
      }
  }
} 
@media screen and (max-width: 900px) {
    .video{
        flex-wrap: wrap;
        iframe:not(:first-child){
          margin-top: 12px;
      }
  }
}
}
</style>
